export enum Role {
  Any = 0,
  GlobalAdmin = 1,
  Partner = 2,
  User = 3,
}

export namespace Role {
  export function availableSelectionItems(currentRole?: Role): Role[] {
    switch (currentRole) {
      case Role.GlobalAdmin:
        return [Role.GlobalAdmin, Role.Partner, Role.User];
      case Role.Partner:
        return [Role.Partner, Role.User];
      default:
        return [];
    }
  }

  export function name(role?: Role) {
    switch (role) {
      case Role.GlobalAdmin:
        return 'users.roles.admin';
      case Role.Partner:
        return 'users.roles.partner';
      case Role.User:
        return 'users.roles.user';
      default:
        return 'users.roles.user';
    }
  }

  export function mapFromApiValue(role: string): Role {
    switch (role) {
      case 'GLOBAL_ADMIN':
        return Role.GlobalAdmin;
      case 'PARTNER':
        return Role.Partner;
      case 'USER':
        return Role.User;
      default:
        return Role.User;
    }
  }

  export function mapToApiValue(role: Role): string {
    switch (role) {
      case Role.GlobalAdmin:
        return 'GLOBAL_ADMIN';
      case Role.Partner:
        return 'PARTNER';
      case Role.User:
        return 'USER';
      default:
        return 'USER';
    }
  }
}
